/*
 * File: activePrincipleConcentrationMatch.ts
 * Project: meki
 * File Created: Friday, 20th January 2023 2:25:42 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 20th January 2023 6:08:58 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { Product } from '@interfaces';

export function activePrincipleConcentrationMatch(
  product: Product,
  joiner = ', ',
): string {
  const activePrinciplesArray = product.activePrinciple
    .split(';')
    .map((e) => e.trim());
  const concentrations = product.concentration?.split(';').map((e) => e.trim());
  return activePrinciplesArray
    .map((activePrinciple, i) => {
      return `${activePrinciple} ${concentrations?.[i] ?? ''}`.trim();
    })
    .join(joiner);
}
